import { render } from "./title-radio.vue?vue&type=template&id=6255ec9a&scoped=true&ts=true"
import script from "./title-radio.vue?vue&type=script&lang=ts"
export * from "./title-radio.vue?vue&type=script&lang=ts"

import "./title-radio.vue?vue&type=style&index=0&id=6255ec9a&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6255ec9a"]])

export default __exports__